import React, { FC } from 'react'
import styles from './HeaderTitle.module.scss'
import { HeaderTitleProps } from './HeaderTitle.model'

export const HeaderTitle: FC<HeaderTitleProps> = ({ children }) => (
  <div className={styles.infoContent}>{children}</div>
)
